import { render, staticRenderFns } from "./quick-start.component.vue?vue&type=template&id=4a98039c&scoped=true&"
import script from "./quick-start.component.vue?vue&type=script&lang=js&"
export * from "./quick-start.component.vue?vue&type=script&lang=js&"
import style0 from "./quick-start.component.vue?vue&type=style&index=0&id=4a98039c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a98039c",
  null
  
)

export default component.exports